import { baseUrls, createApi } from './apiUtils';

const vehicleApi = {
  evdb: createApi({ baseURL: `${baseUrls.vehicle}/v1/evdb` }),
  vehicles: createApi({ baseURL: `${baseUrls.vehicle}/v1/vehicles` }),
};

const VEHICLE_URLS = {
  MAKES: 'makes',
  MODELS_BY_MAKE: (make: string) => `makes/${make}/models`,
  VEHICLE_DETAILS: 'details',

  CREATE: '/',
  LIST: '/',
  ASSIGN_USER: (vehicleId: string) => `/${vehicleId}/users`,
  UPDATE: (vehicleId: string) => `/${vehicleId}`,
  DELETE: (vehicleId: string) => `/${vehicleId}`,

  ACCEPT_INVITE: '/accept-invite',
};

export const listVehicleMakes = () => vehicleApi.evdb.get(VEHICLE_URLS.MAKES);

export const listVehicleModelsByMake = (make: string) =>
  vehicleApi.evdb.get(VEHICLE_URLS.MODELS_BY_MAKE(make));

export const getVehicleDetails = (make: string, model: string) =>
  vehicleApi.evdb.get(VEHICLE_URLS.VEHICLE_DETAILS, {
    params: { make, model },
  });

export const createVehicle = (vehicleData: any) =>
  vehicleApi.vehicles.post(VEHICLE_URLS.CREATE, vehicleData);

export const listVehicles = (params: any) => vehicleApi.vehicles.get(VEHICLE_URLS.LIST, { params });

export const assignUserToVehicle = (vehicleId: string) =>
  vehicleApi.vehicles.post(VEHICLE_URLS.ASSIGN_USER(vehicleId));

export const updateVehicle = (vehicleId: string, vehicleData: any) =>
  vehicleApi.vehicles.put(VEHICLE_URLS.UPDATE(vehicleId), vehicleData);

export const deleteVehicle = (vehicleId: string) =>
  vehicleApi.vehicles.delete(VEHICLE_URLS.DELETE(vehicleId));

export const acceptVehicleInvite = (token: string) =>
  vehicleApi.vehicles.post(VEHICLE_URLS.ACCEPT_INVITE, { token });

export const listVehiclesByUser = (params: any) => vehicleApi.vehicles.get('/by-user', { params });

export const adminCreateVehicle = (vehicleData: any) =>
  vehicleApi.vehicles.post('/for-user', vehicleData);

export const adminUpdateVehicle = (vehicleId: string, vehicleData: any) =>
  vehicleApi.vehicles.patch(`/for-user/${vehicleId}`, vehicleData);

export const adminDeleteVehicle = (vehicleId: string) =>
  vehicleApi.vehicles.delete(`/for-user/${vehicleId}`);

export const inviteUserToVehicle = (vehicleId: string, userId: string) =>
  vehicleApi.vehicles.post(`/${vehicleId}/invite`, { userId });
